<template>
  <v-container fluid class="d-flex flex-column justify-center height-100-percent">
    <v-row align-content="center">
      <v-col
          cols="12"
          sm="10" offset-sm="1"
          md="8" offset-md="2"
          lg="6" offset-lg="3"
          xl="4" offset-xl="4"
      >
        <v-card elevation="1">
          <v-card-title>
            <img src="/images/acc-logo-rgb.png" alt="America's Call Center" height="100" width="157"
                 class="mx-auto">
          </v-card-title>
          <v-card-text>
            <form @keyup.enter="submit">
              <v-text-field
                  v-model="username"
                  :error-messages="usernameErrors()"
                  disabled
                  filled
                  label="Username"
                  required
                  type="text"
                  @blur="$v.usernamme.$touch()"
              ></v-text-field>
              <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :error-messages="passwordErrors()"
                  :type="showPassword ? 'text' : 'password'"
                  filled
                  label="New Password"
                  required
                  @blur="$v.password.$touch()"
                  @click:append="showPassword = !showPassword"
              ></v-text-field>
              <v-text-field
                  v-model="password_confirmation"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :error-messages="passwordConfirmationErrors()"
                  :type="showPassword ? 'text' : 'password'"
                  filled
                  label="Confirm Password"
                  required
                  @blur="$v.password_confirmation.$touch()"
                  @click:append="showPassword = !showPassword"
              ></v-text-field>
              <v-fade-transition>
                <v-progress-linear
                    v-if="score.value > 0"
                    :color="score.color"
                    :value="score.value"
                    height="25"
                >
                  <template v-slot:default="{ value }">
                    <span>{{ score.text }}</span>
                  </template>
                </v-progress-linear>
              </v-fade-transition>
              <v-btn
                  :disabled="submitted || $v.$invalid"
                  class="mt-4"
                  color="primary"
                  @click="submit"
              >
                Change Password
              </v-btn>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import passwordFormMixin from "../mixins/passwordFormMixin";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import {mapActions, mapMutations} from "vuex";
import {displayErrors} from "../helpers/AppHelper";

export default {
  name: "AppResetPassword",
  validations: {
    username: {required},
    ...passwordFormMixin.validations,
  },
  mixins: [validationMixin, passwordFormMixin],
  data() {
    return {
      username: this.$route.query.username,
    }
  },
  methods: {
    ...mapActions({
      resetPassword: 'auth/resetPassword',
    }),
    ...mapMutations(['setLoggedIn']),
    usernameErrors() {
      const errors = []
      if (!this.$v.username.$dirty) return errors
      if (!this.$v.username.strength) {
        errors.push('Password strength must be "Medium" or stronger.')
      }
      return errors
    },
    submit() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }
      this.resetPassword({
        username: this.username,
        password: this.password,
        token: this.$route.params.token,
      })
          .then((response) => {
            this.setLoggedIn(response.data.user)
            this.$router.replace({name: 'inspections'})
                .catch((e) => {
                  console.log(e)
                })
          })
          .catch((errors) => {
            console.error(errors)
            displayErrors(errors)
          })
          .finally(() => {
            this.submitted = false
          })
    },
  },
}
</script>

<style scoped>

</style>